import classNames from 'classnames';
import Fcm from 'domain/fcm';
import FcmAccount from 'features/fcmAccounts/fcmAccount';
import React, { useState } from 'react';
import { Form } from 'react-bootstrap';

import './FcmAccountEditor.scss'

export interface FcmAccountEditorProps {
    accounts: FcmAccount[];
    fcms: Fcm[];
    onAdd(account: string, fcmId: number): void;
    onUpdate(account: string, fcmId: number): void;
    onRemove(account: string): void;
    showValidationErrors: boolean;
}

const FcmAccountEditor: React.FC<FcmAccountEditorProps> = props => {
    const [accountToAdd, setAccountToAdd] = useState<string>("");
    const [selectedFcm, setSelectedFcm] = useState<number>(null);

    function onClickAdd() {
        props.onAdd(accountToAdd, selectedFcm);
        setAccountToAdd("");
        setSelectedFcm(null);
    }

    function disableAdd(): boolean {
        if(accountToAdd == null || accountToAdd.length < 3)
            return true;
        
        else if(selectedFcm == null || !props.fcms.some(f => f.id === selectedFcm))
            return true;

        return false;
    }

    return <div className="fcm-account-editor">
        <div className="form-inline">
            <Form.Control
                
                placeholder="FCM Account Number"
                value={accountToAdd}
                onChange={ev => setAccountToAdd(ev.target.value)}
            />
            <Form.Control as="select"
                className="ml-2"
                value={selectedFcm ?? ""}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    setSelectedFcm(Number(event.target.value));
                }}
                >
                <option value="">Select FCM</option>
                {props.fcms.map((fcm, i) => (
                    <option key={i} value={fcm.id}>
                        {fcm.name}
                    </option>
                ))}
            </Form.Control>
            <button className="btn" onClick={onClickAdd} disabled={disableAdd()}>
                <i className="material-icons">add</i>
            </button>
        </div>
        {props.accounts.map((account, i) =>
            <div key={i} className="account-row form-inline">
                <span>{i+1}. {account.accountNumber} / </span>
                <Form.Control as="select"
                value={account.fcm.id}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    props.onUpdate(account.accountNumber, Number(event.target.value));
                }}
                >
                {props.fcms.map((fcm, idx) => (
                    <option key={idx} value={fcm.id}>
                        {fcm.name}
                    </option>
                ))}
            </Form.Control>
                <button className='link-button mr-auto' onClick={() => props.onRemove(account.accountNumber)}><i className="material-icons">delete</i></button>
               
            </div>
        )}
        {(!props.accounts.some(acc => acc.fcm.isBillingAccount)) &&
            <div className={classNames({"error-text": props.showValidationErrors})}>At least one StoneX account is required</div>}
    </div>;
}

export default FcmAccountEditor;